// extracted by mini-css-extract-plugin
export default {"meinian-member-statistics":"index_meinian-member-statistics__kB29U"};